export default {
    echarts: {
        day: '按天看',
        week: '按周看',
        month: '按月看',
        startDate: '开始日期',
        endDate: '结束日期',
        moreEcharts: '更多图表',
        app: '应用',
        workFlow: '工作流',
        content: '文案',
        activeDistribution: '活跃分布',
        activeDistributionTip: '月度对话活跃分布图(颜色越深对话次数越多)',
        selectApp: '选择应用',
        to: '至',
        date: '日期：',
        conversationNumber: '对话数：',
        channelConversationNumber: '渠道对话数',
        channelConversationNumberTip: '周期内用户在不同使用渠道与你创建的应用或工作流发生对话的次数及占比情况',
        hosting: '托管',
        selfBuilding: '自建',
        other: '其他',
        conversationNumberTip: '对话次数',
        proportion: '占比：',
        cumulativeConversation: '累计对话',
        conversationChannel: '对话渠道',
        highFrequencyWords: '高频词',
        highFrequencyWordsTip: '周期内用户提问中出现的高频关键词',
        quantity: '数量：',
        clickHighFrequencyWords: '点击高频词查看详情',
        transferToHuman: '转人工',
        transferToHumanTip: '周期内用户与你的应用或工作流对话时触发转人工的次数', 
        transferToHumanNumber: '转人工次数：',
        day1: '日',
        week1: '周',
        month1: '月',
        before: '较前',
        viewDetails: '查看详情',
        notKnowledgeBase: '未命中知识库',
        notKnowledgeBaseTip: '周期内用户与你的知识应用(含工作流中应用)对话时未命中知识库的次数',
        notKnowledgeBaseNumber: '未命中次数：',
        times: '次',
        conversationNumber1: '对话数',
        conversationNumber1Tip: '周期内用户与你创建的应用或工作流发生对话(一次问答)的次数',
        scoreConsumption: '积分消耗',
        scoreConsumptionTip: '周期内使用大模型、插件、工作流和知识库导入所消耗的积分及占比情况',
        selectChannel: '选择渠道',
        scoreConsumptionTip1: '积分消耗：',
        cumulativeConsumption: '累计消耗',
        score: '积分',
        userCount: '用户数',
        userCountTip: '周期内使用你创建的应用或工作流的用户数',
        selectUser: '选择用户',

        userCountTip1: '周期内与你创建的应用或工作流进行过至少一次对话的用户数，周期内同一用户统计一次',
        userCount1: '用户数：',
        total: '总计：',
        export: '导出',
        appName: '应用名称',
        question: '问题',
        answer: '答案',
        keyword: '包含关键词',
        model: '模型/插件',
        useTime: '使用时间',
        view: '查看',
        useDetails: '使用详情',
        typeTip: '类型：',
        timeTip: '时间：',
        modelTip: '模型：',
        keywordTip: '包含关键词：',
        knowledgeBaseTip: '知识库：',
        hitNumber: '命中条数',
        requestTip: '请求：',
        resultTip: '结果：',
        noData: '暂无数据',
        exportHighFrequencyWordRecord: '高频词记录导出',
        totalTip: '总计：',
        source: '来源',
        type: '类型',

        prompt: '问题',
        replyTextO: '默认回复',
        triggerType: '触发方式',
        triggerWord: '意图/关键词', 
        triggerTypeTip: '触发方式：',
        triggerWordTip: '意图/关键词：',
        intention: '意图识别',
        keywords: '关键词',
        workflow: '工作流',
        exportNotHitKnowledgeRecord: '未命中知识库记录导出',
        modelTitle: '模型',
        pluginTitle: '插件',
        knowledgeBaseTitle: '知识库',
        workflowTitle: '工作流',
        knowledgeBaseImport: '知识库导入',
        replyText: '答案',
        operation: '操作',
    }
}